import { render, staticRenderFns } from "./RetailerNotes.vue?vue&type=template&id=ee817966"
import script from "./RetailerNotes.vue?vue&type=script&lang=js"
export * from "./RetailerNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports